import { AiChat } from '@/assets/icons'
import { CircularProgressContinuousSized } from '@/components/loaders/CircularProgressContinuous'
import clsx from 'clsx'
import { useStartMedChronAssetChat } from '../hooks/useStartMedChronAssetChat'

interface MedChronAssetChatButtonProps {
  assetId: string
  matterId: string
}

/**
 * Starts a new assistant chat grounded in the matter's living Medical Chronology.
 */
export default function MedChronAssetChatButton(props: MedChronAssetChatButtonProps) {
  const { assetId, matterId } = props
  const { isLoading, startChat } = useStartMedChronAssetChat({ assetId, matterId })

  return (
    <button
      onClick={() => startChat()}
      disabled={isLoading}
      className={clsx(
        'inline-flex items-center justify-center gap-1 px-3 py-1 rounded-md transition-colors ring-1 ring-brand-500 text-brand-500',
        !isLoading ? 'hover:bg-brand-neutral-200' : ''
      )}
      aria-label="Chat with the Medical Chronology"
    >
      {isLoading ? <CircularProgressContinuousSized size={14} thickness={4} /> : <AiChat className="w-4 h-4" />}
      <span className="text-sm font-semibold leading-5 whitespace-nowrap">Ask Assistant</span>
    </button>
  )
}
